import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Cell } from 'recharts';
import { SLAComplianceData } from '../../../types/dashboard';

interface SLAGaugeChartProps {
  data: SLAComplianceData[];
}

const PRIORITY_COLORS: Record<string, string> = {
  Critical: '#f43f5e',
  High: '#f59e0b',
  Medium: '#38bdf8',
  Low: '#34d399',
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  const item = payload[0]?.payload as SLAComplianceData;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg p-3">
      <p className="text-xs font-semibold text-slate-300 mb-1">{label}</p>
      <p className="text-xs text-emerald-400">On Time: {item?.on_time}</p>
      <p className="text-xs text-rose-400">Breached: {item?.breached}</p>
      <p className="text-xs text-sky-400">Compliance: {item?.compliance_rate}%</p>
    </div>
  );
};

export const SLAGaugeChart: React.FC<SLAGaugeChartProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
        <XAxis dataKey="priority" tick={{ fontSize: 11, fill: '#94a3b8' }} />
        <YAxis tick={{ fontSize: 11, fill: '#94a3b8' }} />
        <Tooltip content={<CustomTooltip />} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Bar dataKey="on_time" name="On Time" radius={[4, 4, 0, 0]}>
          {data.map((entry, index) => (
            <Cell key={index} fill={PRIORITY_COLORS[entry.priority] || '#38bdf8'} opacity={0.9} />
          ))}
        </Bar>
        <Bar dataKey="breached" name="Breached" fill="#f43f5e" radius={[4, 4, 0, 0]} opacity={0.6} />
      </BarChart>
    </ResponsiveContainer>
  );
};
